export default __webpack_public_path__ + "static/media/obj-c.3a5f713d.png";